import {
  FocusCompleteResponse,
  FocusProspectsResponse,
  FocusQueueResponse,
  FocusSessionHistoryItem,
  FocusSessionResponse,
  FocusSnoozeItemType,
  FocusSnoozeResponse,
} from '@business/entities/focusMode';
import { UserId } from '@business/entities/account';
import { Endpoint } from '../endpoint';

/**
 * `viewAs` asks for another rep's queue and is administrator-only server-side. As in
 * fetchSessions, the key is omitted rather than passed as undefined: the request
 * serialiser writes the literal string "undefined" into the query.
 */
export function fetchQueue(fresh = false, viewAs?: UserId) {
  return Endpoint.get<FocusQueueResponse>(`@gc/focus-mode/queue`, {
    params: viewAs ? { fresh: fresh ? 'true' : undefined, viewAs } : { fresh: fresh ? 'true' : undefined },
  });
}

export function fetchProspects(viewAs?: UserId) {
  return Endpoint.get<FocusProspectsResponse>(`@gc/focus-mode/prospects`, {
    params: viewAs ? { viewAs } : undefined,
  });
}

export function startSession() {
  return Endpoint.post<{ session: FocusSessionResponse }>(`@gc/focus-mode/session`);
}

export function fetchSession() {
  return Endpoint.get<{ session: FocusSessionResponse }>(`@gc/focus-mode/session`);
}

/**
 * Past sessions, newest first. userId is admin-only server-side.
 *
 * The key is omitted rather than passed as undefined: the request serialiser writes the
 * literal string "undefined" into the query, which the endpoint rejects as a non-integer.
 */
export function fetchSessions(limit?: number, userId?: string) {
  return Endpoint.get<{ sessions: FocusSessionHistoryItem[] }>(`@gc/focus-mode/sessions`, {
    params: userId ? { limit, userId } : { limit },
  });
}

export function heartbeat(actionsTaken = 0) {
  return Endpoint.post<{ session: FocusSessionResponse }>(`@gc/focus-mode/heartbeat`, { data: { actionsTaken } });
}

export function endSession() {
  return Endpoint.post<{ session: FocusSessionResponse | null }>(`@gc/focus-mode/end-session`);
}

export function snoozeItem(itemType: FocusSnoozeItemType, itemId: string, minutes: number) {
  return Endpoint.post<FocusSnoozeResponse>(`@gc/focus-mode/snooze`, { data: { itemType, itemId, minutes } });
}

export function unsnoozeItem(itemType: FocusSnoozeItemType, itemId: string) {
  return Endpoint.post<{ status: boolean }>(`@gc/focus-mode/unsnooze`, { data: { itemType, itemId } });
}

export function completeItem(itemType: FocusSnoozeItemType, itemId: string, actionsTaken = 0) {
  return Endpoint.post<FocusCompleteResponse>(`@gc/focus-mode/complete`, { data: { itemType, itemId, actionsTaken } });
}
